export default function Charity() {
  return (
    <svg
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 416 416"
      style={{ enableBackground: 'new 0 0 416 416' }}
      xmlSpace="preserve"
      className="w-8 h-8 fill-current text-white"
    >
      <g>
        <g>
          <path
            d="M297.776,47.561C276.72,27.721,240.64,23.193,208,55.833c-32.592-32.608-68.72-28.112-89.776-8.288
			c-24.528,23.088-24.96,61.712-1.312,85.36L208,224.009l91.088-91.088C322.736,109.273,322.304,70.649,297.776,47.561z
			 M287.776,121.593L208,201.385l-79.776-79.776c-17.312-17.328-16.976-45.504,0.976-62.4c7.648-7.232,17.888-11.2,28.832-11.2
			c22.912,0,33.216,13.696,49.968,30.448c16.304-16.304,26.8-30.448,49.968-30.448c10.944,0,21.184,3.968,28.848,11.184
			C304.72,76.057,305.136,104.233,287.776,121.593z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M388.656,48.009c-14.096,0-25.792,10.56-27.2,24.576l-10.128,100.016c-4.88,1.04-9.36,3.408-12.832,6.88l-80.816,75.232
			c-11.12,10.128-17.568,24.576-17.68,39.68v89.616h96v-42.176c0-6.512,2.736-12.848,7.696-17.552l60.72-61.28
			c7.472-7.552,11.584-17.552,11.584-28.16V75.353C416,60.281,403.728,48.009,388.656,48.009z M400,234.841
			c0,6.368-2.464,12.368-6.96,16.912l-60.528,61.088c-7.952,7.52-12.512,18.08-12.512,28.992v26.176h-64v-73.52
			c0.08-10.608,4.608-20.768,12.528-27.968l81.072-75.504c2.176-2.176,5.152-3.248,8.304-2.928c1.744,0.16,4.256,0.784,6.4,2.928
			c1.968,1.968,3.056,4.592,3.056,7.36c0,2.768-1.104,5.392-2.784,7.088l-62.416,56.608l10.752,11.84l62.704-56.88
			c4.992-4.992,7.744-11.616,7.744-18.672c0-7.056-2.736-13.68-7.728-18.656c-2.432-2.464-5.264-4.352-8.368-5.648l10.096-99.84
			c0.592-5.824,5.456-10.208,11.296-10.208c6.256,0,11.344,5.088,11.344,11.344V234.841z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M158.32,254.713l-80.816-75.232c-3.472-3.472-7.952-5.856-12.832-6.88L54.544,72.585
			c-1.408-14.016-13.104-24.576-27.2-24.576C12.272,48.009,0,60.281,0,75.353v159.488c0,10.608,4.112,20.608,11.584,28.144
			l60.72,61.28c4.96,4.704,7.696,11.056,7.696,17.568v42.176h96v-89.616C175.904,279.289,169.44,264.857,158.32,254.713z
			 M160,368.009H96v-26.176c0-10.896-4.56-21.472-12.512-28.992L22.96,251.753c-4.496-4.544-6.96-10.544-6.96-16.912V75.353
			c0-6.256,5.088-11.344,11.344-11.344c5.84,0,10.704,4.384,11.296,10.176l10.096,99.84c-3.104,1.312-5.936,3.2-8.368,5.648
			c-4.976,4.976-7.728,11.6-7.728,18.656c0,7.056,2.752,13.68,7.744,18.672l62.704,56.88l10.752-11.84l-62.416-56.608
			c-1.696-1.696-2.784-4.304-2.784-7.088s1.088-5.392,3.056-7.36c2.128-2.144,4.656-2.768,6.4-2.928
			c3.168-0.304,6.128,0.752,8.304,2.928l81.072,75.504c7.92,7.2,12.448,17.36,12.528,27.968V368.009z"
          />
        </g>
      </g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
    </svg>
  );
}
